import styled, { css } from "styled-components";

import colors from "@src/common/styles/colors";
import { DEFAULT_MARGIN_L, DEFAULT_MARGIN_XL } from "@src/common/styles/const";
import { defaultLetterSpacing, media } from "@src/common/styles/mixins";

export type PanelStyle = "light" | "dark";

interface Props {
  panelStyle: PanelStyle;
}

export const Panel = styled.div<Props>`
  display: flex;
  flex-direction: column;
  padding: ${DEFAULT_MARGIN_L}px;
  border-radius: ${DEFAULT_MARGIN_XL}px;

  background-color: ${({ panelStyle }) =>
    panelStyle === "dark" ? colors.gray1 : colors.white};

  ${({ panelStyle }) =>
    panelStyle === "light" &&
    css`
      box-shadow: 0px 4px 20px rgba(3, 74, 100, 0.1);
    `}
`;

export const PanelHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: ${DEFAULT_MARGIN_L}px;
`;

export const PanelTitle = styled.h2`
  display: flex;
  align-items: center;
  margin: 0;
  ${defaultLetterSpacing};
  font-size: 18px;
  font-weight: 600;

  svg {
    margin-left: 10px;
  }

  ${media.down("MOBILE")`
    font-size:14px;
  `}
`;
